import React from 'react';
import { motion } from 'framer-motion';
import AZD from '../../assets/logos/AL.png';
import { Link } from 'react-router-dom';

// Palette white / gold
const colors = {
  bg: '#FFFFFF',
  gold: '#C69C6D',
  goldDark: '#B88A56',
  goldLight: '#F5E1C8',
  text: '#3B2F2A',
  textSoft: '#5C4A3D',
  cardBg: 'rgba(255, 255, 255, 0.75)',
  cardBorder: 'rgba(198, 156, 109, 0.25)',
  shadow: '0 8px 24px rgba(107, 90, 70, 0.06)',
  shadowHover: '0 16px 32px rgba(184, 138, 86, 0.2)',
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5 } },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const services = [
  {
    id: 1,
    image: 'images/services/toyota.jpg',
    title: 'Location de Voiture',
    link: '/RentCars',
    texts: 'Azyekos vous invite à vivre une évasion unique, alliant raffinement, liberté, confort et art de vivre sur mesure.',
  },
];

const ServiceGridCarsx = () => {
  return (
    <>
      <style>{`
        .cars-section {
          background: ${colors.bg};
          padding: 80px 0;
          position: relative;
          overflow: hidden;
        }

        /* Subtle gold aura */
        .cars-section::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(circle at 30% 40%, ${colors.goldLight}40, transparent 50%),
                      radial-gradient(circle at 70% 60%, ${colors.goldLight}30, transparent 50%);
          z-index: 0;
        }

        .container {
          position: relative;
          z-index: 1;
        }

        .section-title {
          font-size: clamp(2rem, 5vw, 2.8rem);
          font-weight: 700;
          color: ${colors.text};
          letter-spacing: -0.5px;
          margin-bottom: 0.5rem;
        }

        .section-subtitle {
          font-size: 1.1rem;
          color: ${colors.textSoft};
          max-width: 600px;
          margin: 0 auto 50px;
          line-height: 1.6;
        }

        .title-underline {
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, ${colors.gold}, ${colors.goldDark});
          margin: 10px auto 0;
          border-radius: 2px;
        }

        /* Card glassmorphism */
        .car-card {
          background: ${colors.cardBg};
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid ${colors.cardBorder};
          border-radius: 30px;
          box-shadow: ${colors.shadow};
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.2, 0.8, 0.2, 1);
          cursor: pointer;
        }

        .car-card:hover {
          transform: translateY(-6px);
          box-shadow: ${colors.shadowHover};
          border-color: ${colors.gold};
        }

        .car-card:hover .card-img-overlay {
          opacity: 0.2;
        }

        .car-card-img {
          position: relative;
          height: 500px;
          overflow: hidden;
        }

        .car-card-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        .car-card:hover .car-card-img img {
          transform: scale(1.03);
        }

        .card-img-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, ${colors.goldLight} 0%, ${colors.gold} 100%);
          opacity: 0;
          transition: opacity 0.4s ease;
          mix-blend-mode: overlay;
        }

        .car-card-body {
          padding: 30px;
          display: flex;
          align-items: flex-start;
          gap: 20px;
        }

        .car-icon {
          width: 60px;
          height: 60px;
          object-fit: contain;
          filter: drop-shadow(0 4px 6px rgba(0,0,0,0.05));
          flex-shrink: 0;
        }

        .car-info h4 {
          font-size: 1.6rem;
          font-weight: 700;
          color: ${colors.text};
          margin-bottom: 10px;
        }

        .car-info h4 a {
          color: inherit;
          text-decoration: none;
          transition: color 0.2s;
        }

        .car-info h4 a:hover {
          color: ${colors.gold};
        }

        .car-info p {
          font-size: 1rem;
          color: ${colors.textSoft};
          line-height: 1.7;
          margin-bottom: 15px;
        }

        .car-cta {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-weight: 600;
          color: ${colors.gold};
          text-decoration: none;
          font-size: 1rem;
          transition: all 0.3s;
          border-bottom: 2px solid transparent;
        }

        .car-cta:hover {
          color: ${colors.goldDark};
          border-bottom-color: ${colors.gold};
        }

        .car-cta i {
          transition: transform 0.3s;
        }

        .car-cta:hover i {
          transform: translateX(5px);
        }

        /* Boutons globaux */
        .btn-gold {
          background: linear-gradient(135deg, ${colors.gold}, ${colors.goldDark});
          color: #fff;
          border: none;
          padding: 0.8rem 2rem;
          border-radius: 50px;
          font-weight: 600;
          font-size: 1rem;
          transition: all 0.3s;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          box-shadow: 0 8px 20px rgba(198, 156, 109, 0.3);
        }

        .btn-gold:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 28px rgba(198, 156, 109, 0.4);
          color: #fff;
        }

        .btn-outline-gold {
          background: transparent;
          color: ${colors.gold};
          border: 2px solid ${colors.gold};
          padding: 0.8rem 2rem;
          border-radius: 50px;
          font-weight: 600;
          font-size: 1rem;
          transition: all 0.3s;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .btn-outline-gold:hover {
          background: ${colors.gold};
          color: #fff;
          transform: translateY(-2px);
        }

        @media (max-width: 768px) {
          .cars-section {
            padding: 60px 0;
          }
          .car-card-img {
            height: 350px;
          }
          .car-card-body {
            flex-direction: column;
          }
        }
      `}</style>

      <section className="cars-section">
        <div className="container">
          {/* Titre */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={containerVariants}
            className="text-center mb-5"
          >
            <h2 className="section-title">Location Exclusive</h2>
            <p className="section-subtitle">
              Découvrez notre collection de véhicules prestigieux pour toutes vos occasions
            </p>
            <div className="title-underline" />
          </motion.div>

          {/* Carte unique */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={cardVariants}
            className="row justify-content-center"
          >
            {services.map((service) => (
              <div className="col-12 col-md-10 col-lg-8" key={service.id}>
                <div className="car-card">
                  <div className="car-card-img">
                    <img src={service.image} alt={service.title} loading="lazy" />
                    <div className="card-img-overlay" />
                  </div>
                  <div className="car-card-body">
                    <img src={AZD} alt="icône" className="car-icon" />
                    <div className="car-info">
                      <h4>
                        <Link to={service.link}>{service.title}</Link>
                      </h4>
                      <p>{service.texts}</p>
                      <Link to={service.link} className="car-cta">
                        En savoir plus <i className="fa fa-arrow-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </motion.div>

          {/* Boutons d'action */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-center mt-5"
          >
            <div className="d-flex gap-3 justify-content-center flex-wrap">
              <Link to="/RentCars" className="btn-gold">
                Voir tous les véhicules
              </Link>
              <Link to="/Contact" className="btn-outline-gold">
                Nous contacter
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default ServiceGridCarsx;